/* Amy & Ivy — custom cart drawer.
   Zelfde motor als Zeyna's cart: direct openen met de laatst bekende cart,
   optimistische wijzigingen gebundeld in één /cart/update.js op variant-id,
   chirurgische DOM-updates, en het thema-dialog dat nooit modaal mag openen. */
(function () {
  'use strict';
  if (window.__AICart) return;
  if (!window.fetch || !window.fetch.bind) return;
  window.__AICart = { pending: true };
  // Pas als het script echt draait mag de CSS het thema-dialog verbergen;
  // faalt dit bestand, dan valt de site terug op de gewone thema-cart.
  document.documentElement.classList.add('aic-on');

  var CFG = window.AIC || {};
  var TIERS = CFG.tiers || [];

  // Ruwe fetch vastleggen vóór onze eigen patch: interne calls mogen de
  // add/change-hook verderop nooit zelf triggeren.
  var rawFetch = window.fetch.bind(window);

  // Herkent het cart-dialog van het thema. Let op de nesting in dit thema:
  //   <theme-drawer id="cart-drawer"> <dialog> <cart-drawer-component>
  // Het dialog is dus de OUDER van cart-drawer-component, niet het kind.
  function isThemeCartDialog(d) {
    if (!d || d.tagName !== 'DIALOG') return false;
    try {
      if (d.querySelector('cart-drawer-component')) return true;
      if (d.closest('#cart-drawer')) return true;
    } catch (e) {}
    return false;
  }

  // Het thema-cart-dialog mag nooit openen: showModal maakt de rest van de
  // pagina inert (bevroren cart). We vuren wel async een close-event voor
  // thema-opruimcode die daarop wacht.
  if (window.HTMLDialogElement) {
    ['showModal', 'show'].forEach(function (naam) {
      var orig = HTMLDialogElement.prototype[naam];
      if (!orig) return;
      HTMLDialogElement.prototype[naam] = function () {
        if (isThemeCartDialog(this)) {
          var d = this;
          setTimeout(function () {
            try { d.dispatchEvent(new Event('close')); } catch (e) {}
          }, 0);
          return;
        }
        return orig.apply(this, arguments);
      };
    });
  }

  // De cart-knop in de header draagt on:click="#cart-drawer/toggle". Dat
  // attribuut weghalen zorgt dat het thema zijn eigen lade niet meer opent;
  // onze eigen click-handler blijft gewoon werken.
  function disarmThemeCartTriggers() {
    var nodes;
    try { nodes = document.querySelectorAll('[on\\:click]'); } catch (e) { return; }
    for (var i = 0; i < nodes.length; i++) {
      var val = nodes[i].getAttribute('on:click') || '';
      if (val.indexOf('#cart-drawer') === 0) {
        nodes[i].setAttribute('data-aic-was', val);
        nodes[i].removeAttribute('on:click');
      }
    }
  }

  var root, ov, drawer, els = {};
  var cart = null;
  var rendered = false;
  var lastFocus = null;
  var cmpCache = {};        // handle -> { variant_id: compare_at_price } (cart.js kent dit veld niet)
  var fetchSeq = 0;

  // Wachtrij op variant-id: line-item-keys her-key'en bij elke kortingsgrens.
  var q = { pending: {}, timer: null, inflight: false, dirty: false, last: null, reconciling: false, retried: false };

  function $(s, c) { return (c || root).querySelector(s); }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function money(cents, cur) {
    var c = cur || (cart && cart.currency) || CFG.currency || 'AUD';
    var loc = CFG.locale || undefined;
    if (c === 'AUD') loc = 'en-AU';        // anders toont 'en' "A$" i.p.v. "$"
    try {
      return new Intl.NumberFormat(loc, {
        style: 'currency', currency: c, minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  function img(url, w) {
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_' + w + 'x$1$2');
  }

  function getCart() {
    return rawFetch(CFG.routes.cart + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function post(url, body) {
    return rawFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  // Sequence-bewaakte cart-read: oude/kapotte responses winnen nooit.
  function readCart() {
    var my = ++fetchSeq;
    return getCart().then(function (c) {
      if (my !== fetchSeq) return null;
      if (!c || !c.items) return null;
      return c;
    }).catch(function () { return null; });
  }

  function unitOf(it) { return it.original_price != null ? it.original_price : it.price; }

  function cmpOf(it) {
    var m = cmpCache[it.handle];
    var c = m && m[it.variant_id];
    return (c && c > unitOf(it)) ? c : 0;
  }

  function totals() {
    var original = 0, qty = 0;
    (cart && cart.items || []).forEach(function (it) {
      original += (cmpOf(it) || unitOf(it)) * it.quantity;
      qty += it.quantity;
    });
    return { original: original, final: cart ? cart.total_price : 0, saved: original - (cart ? cart.total_price : 0), qty: qty };
  }

  function sig(c) {
    var s = String(c.total_price) + '|';
    (c.items || []).forEach(function (it) { s += it.variant_id + ':' + it.quantity + ';'; });
    return s;
  }

  function findByVariant(vid) {
    if (!cart) return null;
    for (var i = 0; i < (cart.items || []).length; i++) {
      if (cart.items[i].variant_id === vid) return cart.items[i];
    }
    return null;
  }

  function rowByVariant(vid) {
    var rows = els.body.querySelectorAll('.aic-li');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-variant') === String(vid)) return rows[i];
    }
    return null;
  }

  function hasPending() {
    if (q.inflight || q.timer || q.reconciling) return true;
    for (var k in q.pending) return true;
    return false;
  }

  function paintSync(on) {
    ['subNow', 'subWas', 'discVal'].forEach(function (n) {
      if (els[n]) els[n].classList.toggle('aic-sync', !!on);
    });
  }

  // ---- kortingstrap --------------------------------------------------------

  function tierState(qty) {
    if (!TIERS.length) return null;
    var reached = -1, i;
    for (i = 0; i < TIERS.length; i++) if (qty >= TIERS[i].qty) reached = i;
    var next = reached + 1 < TIERS.length ? TIERS[reached + 1] : null;
    var frac;
    if (!next) frac = 1;
    else {
      var prevQty = reached >= 0 ? TIERS[reached].qty : 0;
      var span = next.qty - prevQty;
      var into = span > 0 ? Math.min(1, Math.max(0, (qty - prevQty) / span)) : 0;
      frac = ((reached + 1) + into) / TIERS.length;
    }
    return { reached: reached, next: next, frac: frac, qty: qty };
  }

  function renderTier(t) {
    if (!t) { els.tier.hidden = true; return; }
    els.tier.hidden = false;
    if (t.next) {
      var need = t.next.qty - t.qty;
      els.tierMsg.innerHTML = 'Add ' + need + ' more item' + (need === 1 ? '' : 's') +
        ' = <b>' + t.next.pct + '% off</b>';
    } else {
      els.tierMsg.innerHTML = "You've unlocked the maximum <b>" + TIERS[TIERS.length - 1].pct + '% off</b>';
    }
    els.tierFill.style.width = (t.frac * 100) + '%';
    var steps = els.tierSteps.querySelectorAll('.aic-tier__step');
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.toggle('is-on', i <= t.reached);
      var lab = steps[i].querySelector('.aic-tier__lab');
      lab.innerHTML = TIERS[i].pct + '% off<span>' + (i <= t.reached ? 'unlocked' : TIERS[i].label) + '</span>';
    }
  }

  // ---- regels --------------------------------------------------------------

  function lineHTML(it) {
    var unit = unitOf(it);
    var cmp = cmpOf(it);
    var opts = (it.options_with_values || [])
      .filter(function (o) { return o.value && o.value.toLowerCase() !== 'default title'; })
      .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' &middot; ');

    return '<div class="aic-li" data-variant="' + it.variant_id + '">' +
      (it.featured_image && it.featured_image.url
        ? '<img class="aic-li__img" src="' + esc(img(it.featured_image.url, 200)) + '" alt="" loading="lazy" width="66" height="88">'
        : '<span class="aic-li__img"></span>') +
      '<div class="aic-li__main">' +
        '<div class="aic-li__top">' +
          '<p class="aic-li__t"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>' +
          '<button type="button" class="aic-li__rm" data-act="rm" aria-label="Remove item">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13"/></svg>' +
          '</button>' +
        '</div>' +
        (opts ? '<p class="aic-li__v">' + opts + '</p>' : '') +
        '<div class="aic-li__prices">' +
          (cmp ? '<span class="aic-li__was">' + money(cmp) + '</span>' : '') +
          '<span class="aic-li__now">' + money(unit) + '</span>' +
        '</div>' +
        '<div class="aic-qty">' +
          '<button type="button" data-act="dec" aria-label="Decrease quantity">&minus;</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-act="inc" aria-label="Increase quantity">+</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function renderItems() {
    if (!cart || !cart.items || !cart.items.length) {
      els.body.innerHTML = '<div class="aic-empty"><p>Your cart is empty.</p>' +
        '<a href="' + esc(CFG.routes.all || '/collections/all') + '">CONTINUE SHOPPING</a></div>';
      return;
    }
    els.body.innerHTML = cart.items.map(lineHTML).join('');
  }

  /* Kortingsnamen: Shopify hangt de staffelkorting op regelniveau,
     cart_level_discount_applications blijft daarbij leeg. */
  function discountTitles() {
    var seen = {}, out = [];
    function add(t) { if (t && !seen[t]) { seen[t] = 1; out.push(t); } }
    if (!cart) return out;
    (cart.cart_level_discount_applications || []).forEach(function (d) { add(d.title); });
    (cart.items || []).forEach(function (it) {
      (it.discounts || []).forEach(function (d) { add(d.title); });
      (it.line_level_discount_allocations || []).forEach(function (a) {
        add(a.discount_application && a.discount_application.title);
      });
    });
    return out;
  }

  function renderFooter() {
    var t = totals();

    els.discRow.hidden = t.saved <= 0;
    if (t.saved > 0) els.discVal.textContent = '− ' + money(t.saved);

    els.pills.innerHTML = discountTitles().map(function (title) {
      return '<span class="aic-pill">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M20.6 13.4 12 22l-9-9V3h10z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg>' +
        esc(title) + '</span>';
    }).join('');

    els.subWas.hidden = t.saved <= 0;
    if (t.saved > 0) els.subWas.textContent = money(t.original);
    els.subNow.textContent = money(t.final);

    els.co.disabled = !t.qty;
    els.ft.hidden = !t.qty;
  }

  function render() {
    if (!cart) return;
    rendered = true;
    var t = totals();
    els.count.textContent = t.qty ? 'Cart · ' + t.qty : 'Cart';
    renderTier(t.qty ? tierState(t.qty) : null);
    renderItems();
    renderFooter();
    fetchCompare();
  }

  // Zelfde regels in beeld? Alleen cijfers bijwerken, geen innerHTML-wipe.
  function hasDupes(c) {
    var seen = {}, items = c.items || [];
    for (var i = 0; i < items.length; i++) {
      if (seen[items[i].variant_id]) return true;
      seen[items[i].variant_id] = 1;
    }
    return false;
  }

  function sameVariantSet(c) {
    if (!rendered) return false;
    var rows = els.body.querySelectorAll('.aic-li');
    var items = c.items || [];
    if (rows.length !== items.length) return false;
    var have = {};
    items.forEach(function (it) { have[it.variant_id] = (have[it.variant_id] || 0) + 1; });
    for (var i = 0; i < rows.length; i++) {
      var v = rows[i].getAttribute('data-variant');
      if (!have[v]) return false;
      have[v]--;
    }
    return true;
  }

  function syncDOM() {
    var t = totals();
    els.count.textContent = t.qty ? 'Cart · ' + t.qty : 'Cart';
    renderTier(t.qty ? tierState(t.qty) : null);
    (cart.items || []).forEach(function (it) {
      var row = rowByVariant(it.variant_id);
      if (!row) return;
      var span = row.querySelector('.aic-qty span');
      if (span && span.textContent !== String(it.quantity)) span.textContent = it.quantity;
    });
    renderFooter();
    if (!t.qty) renderItems();
  }

  function applyCart(c) {
    var changed = !cart || !rendered || sig(c) !== sig(cart);
    var soft = !hasDupes(c) && sameVariantSet(c);
    cart = c;
    if (!changed && rendered) return;
    if (soft) syncDOM(); else render();
  }

  // Drawer opent DIRECT; verversing loopt op de achtergrond.
  function openNow() {
    show();
    if (cart) { if (!rendered) render(); }
    else if (!els.body.firstElementChild) {
      els.body.innerHTML = '<div class="aic-empty"><p>Loading your cart&hellip;</p></div>';
    }
    refresh();
  }

  var retryT = null;
  var retryN = 0;

  function showLoadError() {
    if (rendered) return;
    els.body.innerHTML = '<div class="aic-empty"><p>We couldn&#39;t load your cart.</p>' +
      '<a href="#" data-act="retry">TRY AGAIN</a></div>';
  }

  function refresh() {
    return readCart().then(function (c) {
      if (!c) {
        // Nooit een eeuwige 'Loading…': twee stille herkansingen, daarna een
        // zichtbare foutstaat met een echte uitweg (TRY AGAIN).
        if (!cart) {
          if (retryN < 2 && !retryT) {
            retryN++;
            retryT = setTimeout(function () { retryT = null; refresh(); }, 1500);
          } else if (!retryT && drawer.classList.contains('is-open')) {
            showLoadError();
          }
        }
        return;
      }
      retryN = 0;
      if (hasPending()) return;               // optimistische edits niet overschrijven
      applyCart(c);
    });
  }

  // ---- optimistische hoeveelheid-wijzigingen -------------------------------

  function optimisticQty(vid, qty) {
    var it = findByVariant(vid);
    if (!it) return;
    qty = Math.max(0, qty);
    if (qty === it.quantity && qty !== 0) return;
    it.quantity = qty;
    if (qty === 0) {
      cart.items = cart.items.filter(function (x) { return x.variant_id !== vid; });
    }

    var row = rowByVariant(vid);
    if (row) {
      if (qty === 0) { if (row.parentNode) row.parentNode.removeChild(row); }
      else {
        var span = row.querySelector('.aic-qty span');
        if (span) span.textContent = qty;
      }
    }

    var t = totals();
    els.count.textContent = t.qty ? 'Cart · ' + t.qty : 'Cart';
    renderTier(t.qty ? tierState(t.qty) : null);
    if (!t.qty) { renderItems(); els.ft.hidden = true; }
    paintSync(true);

    q.pending[vid] = qty;
    if (q.timer) clearTimeout(q.timer);
    q.timer = setTimeout(pump, qty === 0 ? 0 : 300);
  }

  function pump() {
    if (q.timer) { clearTimeout(q.timer); q.timer = null; }
    if (q.inflight) return;                   // draaiende flush pakt de rest mee
    var updates = null, k;
    for (k in q.pending) { (updates = updates || {})[k] = q.pending[k]; }
    if (!updates) { if (!hasPending()) paintSync(false); return; }
    q.pending = {};
    q.inflight = true;
    post(CFG.routes.cart + '/update.js', { updates: updates })
      .then(function (c) { if (c && c.items) { q.last = c; q.retried = false; } else { q.dirty = true; } })
      .catch(function () {
        q.dirty = true;
        // Op weg naar de checkout: mislukte batch één keer opnieuw aanbieden.
        if (els.co && els.co.hasAttribute('data-going') && !q.retried) {
          q.retried = true;
          for (var kb in updates) { if (!(kb in q.pending)) q.pending[kb] = updates[kb]; }
        }
      })
      .then(function () {
        q.inflight = false;
        var more = false;
        for (var k2 in q.pending) { more = true; break; }
        if (more || q.timer) { pump(); return; }
        if (q.dirty) {
          // Mislukte flush: server is de waarheid — opnieuw lezen en tonen.
          q.dirty = false;
          q.reconciling = true;
          readCart().then(function (c2) {
            q.reconciling = false;
            if (c2 && !hasPending()) applyCart(c2);
            if (!hasPending()) paintSync(false);
          });
        } else {
          applyCart(q.last);
          q.last = null;
          paintSync(false);
        }
      });
  }

  // Checkout: openstaande wijzigingen eerst doorduwen (max 4s), dan navigeren.
  function goCheckout() {
    if (els.co.hasAttribute('data-going')) return;
    els.co.setAttribute('data-going', '1');
    els.co.classList.add('aic-co--wait');
    if (q.timer) { clearTimeout(q.timer); q.timer = null; }
    pump();
    var start = Date.now();
    (function wait() {
      if (!els.co.hasAttribute('data-going')) return;   // bfcache-herstel: loop annuleren
      if (!hasPending() || Date.now() - start > 4000) {
        window.location.href = '/checkout';
        // Blijft de pagina toch staan (exit-intent app e.d.): knop weer vrijgeven.
        setTimeout(function () {
          els.co.removeAttribute('data-going');
          els.co.classList.remove('aic-co--wait');
        }, 5000);
        return;
      }
      setTimeout(wait, 80);
    })();
  }

  // ---- vergelijkprijzen (cart.js kent geen compare_at_price) ---------------

  function fetchCompare() {
    var todo = {};
    (cart.items || []).forEach(function (it) {
      if (it.handle && cmpCache[it.handle] === undefined) todo[it.handle] = 1;
    });
    Object.keys(todo).forEach(function (h) {
      cmpCache[h] = null;
      rawFetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var m = {};
          (p.variants || []).forEach(function (v) {
            if (v.compare_at_price && v.compare_at_price > v.price) m[v.id] = v.compare_at_price;
          });
          cmpCache[h] = m;
          paintCompare();
        })
        .catch(function () {});
    });
    paintCompare();
  }

  function paintCompare() {
    if (!cart) return;
    var geraakt = false;
    (cart.items || []).forEach(function (it) {
      var cmp = cmpOf(it);
      if (!cmp) return;
      var row = rowByVariant(it.variant_id);
      if (!row) return;
      var prices = row.querySelector('.aic-li__prices');
      if (!prices || prices.querySelector('.aic-li__was')) return;
      var s = document.createElement('span');
      s.className = 'aic-li__was';
      s.textContent = money(cmp);
      prices.insertBefore(s, prices.firstChild);
      geraakt = true;
    });
    if (geraakt) renderFooter();
  }

  // ---- open/dicht ----------------------------------------------------------

  function closeThemeDialog() {
    var host = document.getElementById('cart-drawer');
    if (host && host.hasAttribute('open')) host.removeAttribute('open');
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) {
      if (isThemeCartDialog(open[i]) && open[i].close) {
        try { open[i].close(); } catch (e) {}
      }
    }
  }

  function show() {
    closeThemeDialog();
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    ov.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('aic-lock');
    document.body.classList.add('aic-lock');
    setTimeout(function () { try { els.close.focus(); } catch (e) {} }, 60);
  }

  function hide() {
    ov.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('aic-lock');
    document.body.classList.remove('aic-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  // ---- events --------------------------------------------------------------

  // Welke cart-actie zit er in dit fetch-doel? Alleen same-origin /cart/*.
  function cartAction(u) {
    var href = typeof u === 'string' ? u : (u && (u.url || u.href)) || '';
    if (!href) return '';
    var m = String(href).match(/^(?:(?:https?:)?\/\/([^\/]+))?(\/[^ ]*)$/);
    if (!m) return '';
    if (m[1] && m[1] !== location.host) return '';
    var mm = (m[2] || '').match(/^\/cart\/(add|change|update|clear)(?:\.js|\.json)?(?:\?|$)/);
    return mm ? mm[1] : '';
  }

  function bind() {
    ov.addEventListener('click', hide);
    els.close.addEventListener('click', hide);

    // Tab blijft binnen de open drawer (aria-modal zonder trap is een valkuil).
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      var all = drawer.querySelectorAll('button:not([disabled]), a[href], select, input, [tabindex]:not([tabindex="-1"])');
      var f = [];
      for (var i = 0; i < all.length; i++) {
        if (all[i].offsetParent !== null || all[i] === document.activeElement) f.push(all[i]);
      }
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) hide();
    });

    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-act]');
      if (!btn) return;
      var act = btn.getAttribute('data-act');
      var li = btn.closest('.aic-li');

      if (act === 'dec' || act === 'inc') {
        var vid = parseInt(li.getAttribute('data-variant'), 10);
        var it = findByVariant(vid);
        if (!it) return;
        optimisticQty(vid, it.quantity + (act === 'inc' ? 1 : -1));
      } else if (act === 'rm') {
        optimisticQty(parseInt(li.getAttribute('data-variant'), 10), 0);
      } else if (act === 'retry') {
        e.preventDefault();
        retryN = 0;
        els.body.innerHTML = '<div class="aic-empty"><p>Loading your cart&hellip;</p></div>';
        refresh();
      } else if (act === 'checkout') {
        goCheckout();
      }
    });

    document.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
      var trigger = e.target.closest('[data-testid="cart-drawer-trigger"], .cart-bubble, cart-icon-component');
      var link = e.target.closest('a[href]');
      var isCartLink = false;
      if (link) {
        var href = (link.getAttribute('href') || '').split('#')[0];
        isCartLink = /\/cart\/?($|\?)/.test(href);
      }
      if (!trigger && !isCartLink) return;
      if (e.target.closest('#ai-cart-root')) return;
      e.preventDefault();
      e.stopPropagation();
      openNow();
    }, true);

    // Externe cart-mutaties (bijv. de add-to-cart van de PDP) oppikken.
    var prevFetch = window.fetch;
    window.fetch = function () {
      var action = cartAction(arguments[0]);
      var p = prevFetch.apply(this, arguments);
      if (action === 'add') {
        p.then(function (r) { if (r && r.ok) setTimeout(function () { openNow(); }, 10); }, function () {});
      } else if (action) {
        p.then(function (r) { if (r && r.ok) setTimeout(refresh, 10); }, function () {});
      }
      return p;
    };

    document.addEventListener('cart:refresh', function () { refresh(); });
    document.addEventListener('cart:open', function () { openNow(); });

    // Terug uit de checkout: klik-guard resetten; bij bfcache-herstel ook de
    // wachtrij hard resetten (een bevroren inflight-vlag zou alles blokkeren).
    window.addEventListener('pageshow', function (e) {
      if (els.co) {
        els.co.removeAttribute('data-going');
        els.co.classList.remove('aic-co--wait');
      }
      if (!e.persisted) return;
      if (q.timer) { clearTimeout(q.timer); q.timer = null; }
      q.pending = {}; q.inflight = false; q.dirty = false; q.last = null; q.reconciling = false; q.retried = false;
      paintSync(false);
      refresh();
    });

    // Vertrekt de gebruiker binnen het debounce-venster, dan gaan openstaande
    // wijzigingen alsnog direct de deur uit.
    function flushNow() {
      if (q.timer) { clearTimeout(q.timer); q.timer = null; }
      var updates = null, k;
      for (k in q.pending) { (updates = updates || {})[k] = q.pending[k]; }
      if (!updates) return;
      q.pending = {};
      try {
        rawFetch(CFG.routes.cart + '/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          keepalive: true,
          body: JSON.stringify({ updates: updates })
        });
      } catch (e) {}
    }
    window.addEventListener('pagehide', flushNow);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') { flushNow(); return; }
      // Terug op de tab: dim opheffen en de echte cart-stand ophalen.
      if (!hasPending()) { paintSync(false); refresh(); }
    });

    // Vangnet: het thema hertekent zijn header na cart-updates, waarmee
    // on:click terugkomt. Dus periodiek opnieuw ontwapenen en sluiten.
    setInterval(function () {
      disarmThemeCartTriggers();
      closeThemeDialog();
    }, 1200);
  }

  function init() {
    if (init.did) return;
    init.did = true;
    root = document.getElementById('ai-cart-root');
    if (!root) return;
    ov = $('.aic-ov');
    drawer = $('.aic-d');
    els = {
      count: $('.aic-hd__t'),
      close: $('.aic-hd__x'),
      tier: $('.aic-tier'),
      tierMsg: $('.aic-tier__msg'),
      tierFill: $('.aic-tier__fill'),
      tierSteps: $('.aic-tier__steps'),
      body: $('.aic-body'),
      ft: $('.aic-ft'),
      discRow: $('.aic-row--disc'),
      discVal: $('.aic-neg'),
      pills: $('.aic-pills'),
      subWas: $('.aic-sub__was'),
      subNow: $('.aic-sub__now'),
      co: $('.aic-co')
    };

    var dc = document.querySelector('cart-drawer-component');
    if (dc) dc.removeAttribute('auto-open');
    disarmThemeCartTriggers();
    closeThemeDialog();

    bind();
    refresh();

    // Kwam de bezoeker op /cart binnen? Dan heeft sections/ai-cart-page.liquid
    // hem teruggestuurd naar de vorige pagina en hoort de lade hier open.
    try {
      if (sessionStorage.getItem('aicOpen')) {
        sessionStorage.removeItem('aicOpen');
        openNow();
      }
    } catch (e) {}

    window.__AICart = { open: openNow, close: hide, refresh: refresh };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
